let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("apT9R")).then(() => parcelRequire('9A00a'));